export const reasonsOptions = [
  { id: 'LocationBlockReason', name: 'Location block reason' },
  { id: 'ProfessionalBlockReason', name: 'Professional block reason' },
];

export const referencesOptions = [
  { id: 'Location', name: 'Location' },
  { id: 'Professional', name: 'Professional' },
];

export const kindOptions = [
  { id: 'block', name: 'Block' },
  { id: 'favorite', name: 'Favorite' },
];

export const billingPlanOptions = [
  { id: 'standard', name: '1099' },
  { id: 'enterprise_w2', name: 'W2' },
];

export const format = () => (r) => r?.label ?? '';
